module.exports = __webpack_public_path__ + "img/bearish.58fd3d3f.jpg";